module.exports = __webpack_public_path__ + "static/csharp-933f2e2c1341fd82a7a4b43529429d67.mp4";